<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.Y_AXIS' | translate">
        <ui-select
            formControlName="measureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures.length || disabled"
        />
    </ui-form-field>

    @if (!formGroup.controls.limit.value) {
        <ui-toggle
            class="grid-row-1 toggle"
            formControlName="shouldZeroBeDisplayed"
            [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SHOULD_ZERO_BE_DISPLAYED' | translate"
        />
    }

    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.X_AXIS' | translate">
        <ui-select
            formControlName="xAxisDimensionCode"
            labelField="name"
            valueField="dimensionCode"
            groupField="resourceTypeLabel"
            [options]="availableDimensions"
            [required]="true"
            [disabled]="!availableDimensions.length || disabled"
        />
    </ui-form-field>

    @if ((xAxisDimensionInfo$ | async)?.isTemporalDimension) {
        <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.STEP' | translate">
            <ui-select
                formControlName="xAxisStepCode"
                labelField="label"
                valueField="value"
                [options]="stepList"
                [required]="true"
                [disabled]="!stepList.length || disabled"
                [sortFn]="doNotSort"
            />
        </ui-form-field>

        @if (currentStep$ | async | applyPureFunction: isStartAtAvailable) {
            <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.STEP_CUSTOM_MONTH.START_MONTH' | translate">
                <ui-select
                    formControlName="startAt"
                    [options]="months"
                    [clearable]="true"
                    [disabled]="!months.length || disabled"
                    [sortFn]="doNotSort"
                >
                    <ng-template let-option="option">
                        {{ 'HIGHCHARTS.MONTHS.' + option.toString() | translate }}
                    </ng-template></ui-select
                >
            </ui-form-field>
        }
    }

    @if (isMeasureSegmentable$ | async) {
        <ui-form-field class="grid-row-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SEGMENTATION' | translate">
            <ui-select
                formControlName="segmentationDimensionCode"
                labelField="name"
                valueField="dimensionCode"
                groupField="resourceTypeLabel"
                [options]="(segmentationDimensions$ | async) ?? []"
                [disabled]="!(segmentationDimensions$ | async)?.length || disabled"
                [clearable]="true"
            />
        </ui-form-field>
    }

    @if (
        formGroup.controls.xAxisDimensionCode.value &&
        !(xAxisDimensionInfo$ | async)?.isContinuousDimension &&
        !formGroup.controls.segmentationDimensionCode.value
    ) {
        <ui-form-field class="grid-row-4" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.LIMIT' | translate">
            <input advizeoInput type="number" min="1" step="1" formControlName="limit" />
        </ui-form-field>
        <ui-toggle
            class="grid-row-4 toggle"
            formControlName="isSortReversed"
            [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TOGGLE_REVERSE_SORT' | translate"
        />
    }
</form>
